import ReceivementWeightForm from './ReceivementWeightForm'

export default ReceivementWeightForm
